export const LOCATION_STORAGE_KEY = "location";

export const readLocationCache = () => {
  try {
    const raw = localStorage.getItem(LOCATION_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const writeLocationCache = (data) => {
  if (!data || typeof data !== "object") {
    return;
  }
  localStorage.setItem(LOCATION_STORAGE_KEY, JSON.stringify(data));
  window.dispatchEvent(new CustomEvent("cpai-location-cache-updated"));
};
